import React, { useContext, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { ErpContext } from '../../context/ErpContext.js';
import Cookies from 'js-cookie';

const PrivateRoute = ({ allowedRoles }) => {
  const { user, isNavbarCollapsed, setIsSessionExpired } = useContext(ErpContext);

  // 🔒 Validar cookie de seguridad al acceder a rutas protegidas
  useEffect(() => {
    const tenantCookie = Cookies.get("tenant");
    
    // Si hay usuario pero no hay cookie de seguridad = sesión expirada
    if (user && !tenantCookie) {
      console.warn("⚠️ [PrivateRoute] Cookie tenant no existe, sesión expirada");
      setIsSessionExpired(true);
    }
  }, [user, setIsSessionExpired]);

  // Si no hay usuario, redirige a la página de inicio de sesión
  if (!user) {
    const tenantURL = Cookies.get("tenantURL") || "default";
    return <Navigate to={`/${tenantURL}/login`} replace />;
  }

  // Si se especifican roles permitidos y el rol del usuario no coincide, muestra un mensaje de error o redirige
  if (allowedRoles && !allowedRoles.includes(user.rol)) {
    return <div>No tienes permiso para acceder a esta página.</div>;
  }

  // Si el usuario está autenticado y tiene permiso, renderiza las rutas internas (Outlet)
  return <Outlet />;
};

export default PrivateRoute;
